import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '#src/api/http-client';

const MAX_RETRIES = 2;
const CLIENT_ERROR_MIN = 400;
const SERVER_ERROR_MIN = 500;

/** Erro 4xx não melhora repetindo: falta token, permissão ou o corpo está errado. */
const isClientError = (error: unknown): boolean =>
  error instanceof ApiError &&
  error.status >= CLIENT_ERROR_MIN &&
  error.status < SERVER_ERROR_MIN;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // A pessoa alterna entre o chat e a aba do app: ao voltar, atualiza.
        refetchOnWindowFocus: true,
        retry: (failures, error) =>
          !isClientError(error) && failures < MAX_RETRIES,
      },
      mutations: { retry: false },
    },
  });
}
